import React from "react"
import PropTypes from "prop-types"

import ThemeConsumer from "../../../ThemeConsumer"
import { INVOICE_CLOSE_MODAL_BUTTON } from "shared/constants/idsElements"
import Typograph from "../../../../../components/Typograph"

const HeaderSecondary = ({ theme, icons, onClose, title, description }) => {
  return (
    <header className={theme.containerHeaderSecondary}>
      <div className={theme.headerInfo}>
        <Typograph
          htmlTag="h1"
          size="x_large"
          color="outer_space"
          weight="bold"
        >
          {title}
        </Typograph>
        <Typograph
          htmlTag="p"
          size="medium"
          color="spanish_gray"
          weight="regular"
        >
          {description}
        </Typograph>
      </div>
      <button onClick={onClose} id={INVOICE_CLOSE_MODAL_BUTTON}>
        <img src={icons.closeButtonSecondary.type} alt="Close" />
      </button>
    </header>
  )
}
HeaderSecondary.propTypes = {
  theme: PropTypes.object,
  icons: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
}
export default ThemeConsumer("UIModernModal")(HeaderSecondary)



// WEBPACK FOOTER //
// ./src/shared/components/ModernModal/components/ModalHeader/HeaderSecondary.js